import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UserHierarchyQueryVariables = Types.Exact<{
  userId: Types.Scalars['String']['input'];
}>;


export type UserHierarchyQuery = { user?: { id: string, name?: string | null, profilePicture?: string | null, hierarchyPath?: string | null } | null };


export const UserHierarchyDocument = /*#__PURE__*/ gql`
    query UserHierarchy($userId: String!) {
  user(filters: {userId: $userId}) {
    id
    name
    profilePicture
    hierarchyPath
  }
}
    `;

export function useUserHierarchyQuery(options: Omit<Urql.UseQueryArgs<UserHierarchyQueryVariables>, 'query'>) {
  return Urql.useQuery<UserHierarchyQuery, UserHierarchyQueryVariables>({ query: UserHierarchyDocument, ...options });
};